import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AggregationRequest } from '../common-interfaces-classes/AggregationRequest';

@Injectable({
  providedIn: 'root'
})
export class InsightsDataService {

  constructor() { }

  private insightsActive = false;

  setInsightsActive(insightsActive: boolean) {
    this.insightsActive = insightsActive;
  }

  get isInsightsActive()  {
    return this.insightsActive;
  }

}

